import axios from "../../utils/axios";
import stringUtils from "../../utils/stringUtils";

const apiUrl = process.env.REACT_APP_HS_API_URL;

export interface Consultant {
  id: string;
  firstName?: string;
  lastName?: string;
  consultantDescription?: string;
  photoUrl?: string;
  email?: string;
  phone?: string;
  siteExternalId?: string;
}

const fetchConsultantForAccounts = (accountExternalIds) => {
  const queryString = stringUtils.buildQueryStringList(
    "externalIds",
    accountExternalIds
  );
  return axios.get<Consultant[]>(`${apiUrl}/consultant/accounts${queryString}`);
};

const consultantService = {
  fetchConsultantForAccounts,
};

export default consultantService;
